import { CheckBox } from 'components/CheckBox/CheckBox';
import { InputField } from 'components/InputField/InputField';
import React from 'react';
import { emailRegex } from 'utils/validation';
import { Wrapper } from './Theme';

export const CommunicationSection = ({ formik }) => {
    const CheckBoxItems = [
        { label: 'Education- Sign Up Email', key: 'registrationEmail' }, 
        { label: 'Education- Enrollment Approved', key: 'approvalEmail' },
        { label: 'Education- Enrollment Denied', key: 'rejectEmail' },
    ]
    const donationCheckBoxItems = [
        { label: "Donation - Email to the donor using bill my account", key: 'donationBill' },
        { label: "Donation - Email to the donor without tribute", key: 'donationWithoutTribute' },
        { label: "Donation - Email to the donor with a tribute", key: 'donationWithTribute' },
        { label: "Donation - Email to the recipient", key: 'donationRecipient' },
    ]
    const handleOnChange = (value) => {
        formik.setFieldValue('email.replyTo', value)
        if (!value) {
            formik.setFieldValue('email.error', false)
        } else {
            !emailRegex.test(value) ? formik.setFieldValue('email.error', true) : formik.setFieldValue('email.error', false)
        }
    }
    return (
        <Wrapper>
            {CheckBoxItems?.map((item) => (
                <CheckBox
                    key={item?.key}
                    checked={formik?.values?.education[item?.key]}
                    onChange={() => formik.setFieldValue(`education[${item?.key}]`, !formik?.values?.education[item?.key])}
                    text={item?.label}
                />
            ))}
            {donationCheckBoxItems?.map((item) => (
                <CheckBox
                    key={item?.key}
                    checked={formik?.values?.donation[item?.key]}
                    onChange={() => formik.setFieldValue(`donation[${item?.key}]`, !formik?.values?.donation[item?.key])}
                    text={item?.label}
                />
            ))}
            <InputField label='Default reply to email' type="text" formik={formik}
                message={'Please enter valid email'}
                value={formik.values?.email?.replyTo} onChange={(e) => handleOnChange(e?.target?.value)}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                    }
                }}

                style={{
                    width: '230px', height: '35px'
                }}
                styleWrapper={{
                    display: 'flex', flexDirection: 'column', paddingLeft: '1px', justifyContent: 'center',
                    marginLeft: '20px'
                }}
                Wrapper={{ flexDirection: 'row', alignItems: 'baseline' }}
                labelStyle={{ color: 'black', fontSize: '12px', fontWeight: 400 }}
                error={formik.values?.email?.error}
            />
        </Wrapper>
    );
};
